import { ActionReducer, Action } from "@ngrx/store";
import { WorkshopsStore } from "@store/workshops";
import { Workshop } from "@models/workshop";

export const workshopsReducer: ActionReducer<WorkshopsStore> = (state: WorkshopsStore = new WorkshopsStore(), action: Action) => {

  switch(action.type) {
    case POPULATE_WORKSHOPS:
      return new WorkshopsStore(
        [...action.payload],
        state.activeWorkshop,
        state.activeCampus)

    case POPULATE_ACTIVE_WORKSHOP:
      return new WorkshopsStore(
        [...state.workshops],
        action.payload,
        state.activeCampus)

    case POPULATE_ACTIVE_CAMPUS:
      return new WorkshopsStore(
        [...state.workshops],
        state.activeWorkshop,
        action.payload)

    case REPLACE_WORKSHOP:
      const p = action.payload
      const workshops = state.workshops.map((w: Workshop) => {
        if (w.id === action.payload.id) { return action.payload }
        return w
      })
      const activeWorkshop = action.payload.id == state.activeWorkshop.id ?
        action.payload : state.activeWorkshop

      return new WorkshopsStore(
        [...workshops],
        activeWorkshop,
        state.activeCampus)

    default:
      return state

  }
}

export const FETCH_WORKSHOPS = "FETCH_WORKSHOPS"
export const POPULATE_WORKSHOPS = "POPULATE_WORKSHOPS"
export const FETCH_WORKSHOPS_FAILURE = "FETCH_WORKSHOPS_FAILURE"
export const POPULATE_ACTIVE_WORKSHOP = "POPULATE_ACTIVE_WORKSHOP"
export const POPULATE_ACTIVE_CAMPUS = "POPULATE_ACTIVE_CAMPUS"
export const UPDATE_WORKSHOP = "UPDATE_WORKSHOP"
export const REPLACE_WORKSHOP = "REPLACE_WORKSHOP"
export const UPDATE_WORKSHOP_FAILURE = "UPDATE_WORKSHOP_FAILURE"
export const CREATE_WORKSHOP_ABSENCE = "CREATE_WORKSHOP_ABSENCE"
export const CREATE_WORKSHOP_ABSENCE_FAILURE = "CREATE_WORKSHOP_ABSENCE_FAILURE"
export const ADD_WORKSHOP_ABSENCE = "ADD_WORKSHOP_ABSENCE"
export const DELETE_WORKSHOP_ABSENCE = "DELETE_WORKSHOP_ABSENCE"
export const DELETE_WORKSHOP_ABSENCE_FAILURE = "DELETE_WORKSHOP_ABSENCE_FAILURE"
export const REMOVE_WORKSHOP_ABSENCE = "REMOVE_WORKSHOP_ABSENCE"
export const WORKSHOPS_ROLLOVER = "WORKSHOPS_ROLLOVER"
export const WORKSHOPS_ROLLOVER_SUCCESS = "WORKSHOPS_ROLLOVER_SUCCESS"
export const WORKSHOPS_ROLLOVER_FAILURE = "WORKSHOPS_ROLLOVER_FAILURE"



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/reducers/workshops.ts